export default __webpack_public_path__ + "static/media/01.ecfab0aa.jpg";